import React from "react";

const publicUrl = process.env.PUBLIC_URL;
const proposalTableShadow = `${publicUrl}/assets/images/proposal-table-shadow.png`;
const logoIcon = `${publicUrl}/assets/images/logo-icon.png`;


interface ProposalAmenetiesProps {
    getAmenityIcon: (amenityName: string) => string;
    index: number;
    propertyData: any;
}


export default function ProposalAmeneties({ getAmenityIcon,
    index,
    propertyData }: ProposalAmenetiesProps) {
    return (
        <table className="table-outer-area page-break"
            style={{
                // backgroundImage: `url(${require("../../../assets/images/proposal-table-shadow.png")})`,
                backgroundImage: `url(${proposalTableShadow})`,
                backgroundRepeat: "no-repeat",
                backgroundPosition: "bottom",
                backgroundSize: "cover",
                marginTop: "15px",
                minHeight: "794px",
            }}
            width="100%"
            cellPadding="10"
            cellSpacing="0"
        >
            <tbody>
                <tr>
                    <td align="right">
                        <img
                            width={110}
                            src={logoIcon}
                            alt="property image"
                        />
                    </td>
                </tr>

                <tr>
                    <td width="100%" className="pl-40"
                        style={{
                            color: "#021D77",
                            marginTop: "-57px",
                            display: "block",
                        }}
                    >
                        <span style={{ fontSize: "18px" }}>
                            O P T I O N {index + 1}
                        </span>
                        <br />
                        <div style={{ display: 'flex', }}>
                            <strong
                                style={{ fontSize: "25px", fontWeight: 700, maxWidth: '80%', flexShrink: 0 }}
                            >
                                {propertyData?.propertyName?.toUpperCase()}
                            </strong>
                            <div style={{ height: '4px', width: '100%', backgroundColor: '#C39864', marginTop: '18px', marginLeft: '10px' }}></div>
                        </div>
                    </td>
                </tr>

                <tr>
                    <td style={{ padding: "0" }}>
                        <table
                            cellPadding="20"
                            cellSpacing="0"
                            width="100%"
                        >
                            <tbody>
                                <tr>
                                    <td colSpan={4} height="15"></td>
                                </tr>
                                <tr>
                                    <td>
                                        <table
                                            width="100%"
                                            cellPadding="0"
                                            cellSpacing="0"
                                        >
                                            <tbody>
                                                <tr>
                                                    <td>
                                                        <table
                                                            width="100%"
                                                            cellPadding="0"
                                                            cellSpacing="12"
                                                            style={{
                                                                borderCollapse: "separate",
                                                            }}
                                                        >
                                                            <tbody>
                                                                <tr>
                                                                    <td colSpan={4}>
                                                                        <span
                                                                            style={{
                                                                                fontSize: "19px",
                                                                                color: "#8FA9D4",
                                                                                fontWeight: 700,
                                                                            }}
                                                                        >
                                                                            <u>AMENITIES</u>
                                                                        </span>
                                                                    </td>
                                                                    <tr>
                                                                        <td height="10"></td>
                                                                    </tr>
                                                                </tr>
                                                                <tr>
                                                                    <td>
                                                                        <div className="row gutter-8">
                                                                            {propertyData.amenities.map(
                                                                                (
                                                                                    amenity: {
                                                                                        attrOptName: string;
                                                                                    }) => (
                                                                                    <div className="col-md-3 mb-3">
                                                                                        <div
                                                                                            style={{
                                                                                                boxShadow:
                                                                                                    "0px 1px 5px 1px #00000040",
                                                                                                backgroundColor: "#fff",
                                                                                                // backgroundColor: "#F8F5FA",
                                                                                                borderRadius: "5px",
                                                                                                overflow: "hidden",
                                                                                                padding: "5px",
                                                                                            }}
                                                                                            className="box-shadow"
                                                                                        >
                                                                                            <table
                                                                                                width="100%"
                                                                                                cellPadding="8"
                                                                                                cellSpacing="0"

                                                                                            >
                                                                                                <tbody>
                                                                                                    <tr>
                                                                                                        <td width="17%">
                                                                                                            <img
                                                                                                                width="42"
                                                                                                                // src={require(`../../../assets/images/proposal/aminities_1.png`)}
                                                                                                                src={getAmenityIcon(amenity.attrOptName)}
                                                                                                                alt="property_image"
                                                                                                                style={{
                                                                                                                    width: "34px",
                                                                                                                    margin: "8px", height: "34px",
                                                                                                                    objectFit: 'contain',
                                                                                                                }}

                                                                                                            />
                                                                                                        </td>
                                                                                                        <td
                                                                                                            width="83%"
                                                                                                            style={{
                                                                                                                fontSize:
                                                                                                                    "17px",
                                                                                                                color:
                                                                                                                    "#5E5E5E",
                                                                                                                fontWeight: 400,
                                                                                                            }}
                                                                                                        >
                                                                                                            {/* {idx === 0
                                                        ? ""
                                                        : " | "} */}
                                                                                                            {
                                                                                                                amenity.attrOptName
                                                                                                            }
                                                                                                        </td>
                                                                                                    </tr>
                                                                                                </tbody>
                                                                                            </table>
                                                                                        </div>
                                                                                    </div>
                                                                                )
                                                                            )}
                                                                        </div>

                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </td>
                </tr>

                <tr>
                    <td height="220"></td>
                </tr>
                <tr>
                    <td
                        height="50"
                        style={{ backgroundColor: "#021D77" }}
                    ></td>
                </tr>
            </tbody>
        </table>
    );
}
